import React from 'react/addons'
import formatNumber from 'lib/formatNumber'
import fillEmpty from './fillEmpty'
import inCart from 'lib/inCart'

let cx = React.addons.classSet

const filler = '&nbsp&nbsp'

const Tbl = React.createClass({
	mixins: [React.addons.PureRenderMixin],

	getDefaultProps() {
		return {
			dict: {},
			rows: [],
			cols: [],
			currentRow: null,
			currentCol: null
		};
	},

	propTypes: {
		dict: React.PropTypes.object.isRequired,
		currentRow: React.PropTypes.string,
		currentCol: React.PropTypes.string,
		cols: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
		rows: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
	},

	makeRef(d, name) {
		return 'c' + d + name.split(/,| |\./).join('')
	},

	handleCellMouseOver(d, name, empty) {
		empty = empty === undefined ? false : empty
		if(this.props.currentRow === d && this.props.currentCol === name) {
			return
		}

		let sightPos = {}

		if(!empty) {
			let el = this.getDOMNode().getBoundingClientRect()
			let cell1 = this.refs[this.makeRef(d, name)].getDOMNode()
			let cell2 = cell1.nextSibling.getBoundingClientRect()
			cell1 = cell1.getBoundingClientRect()
			sightPos = {
				width: cell1.width + cell2.width,
				height: cell1.height,
				top: cell1.top - el.top,
				left: cell1.left - el.left
			}
		} else {
			sightPos = {left: -9999, top: -9999}
		}

		this.props.onCurrentChange(d, name, sightPos)
	},

	renderCell(cell, row, col, nextCol, len) {
		let ref = this.makeRef(row, col)
		let handler = this.handleCellMouseOver.bind(this, cell && row, cell && col, !cell)
		// console.log()
		let added = cell && inCart(this.props.cart.items, cell.id, this.props.productId)
		let thickCl = cx({
			'cur': col === this.props.currentCol,
			'added': added,
		})
		let massCl = cx({
			'cur': col === this.props.currentCol,
			'added': added,
			'preCur': nextCol === this.props.currentCol
		})

		let thick = cell
					? formatNumber(cell.thick, len.thick[0], len.thick[1], filler)
					: fillEmpty(len.thick, filler)

		let mass = cell
					? formatNumber(cell.mass, len.mass[0], len.mass[1], filler)
					: fillEmpty(len.mass, filler)

		return [
			<td className={thickCl} ref={ref} onMouseOver={handler} dangerouslySetInnerHTML={{__html: thick}} />,
			<td className={massCl} onMouseOver={handler} dangerouslySetInnerHTML={{__html: mass }} />
		]
	},

	renderHeader(cols) {
		return (
			<thead>
				<tr>
					<th rowSpan="2" dangerouslySetInnerHTML={{__html: 'Наруж.&nbspø'}} />
					{cols.map(col => <th key={col} colSpan="2">{col}</th>)}
					{this.props.customCols.map(col => <th rowSpan="2" key={col}>{col}</th>)}
				</tr>
				<tr>
					{cols.map(col => [
						<th key={col+'_2'}>Толщ-а<br />стенки,<br />мм</th>,
						<th key={col+'_1'}>Вес,<br />кг</th>
					])}
				</tr>
			</thead>
		)
	},

	renderRow(d) {
		const { dict, initialDict, cols, currentCol, currentRow, customCells, customCols } = this.props;

		return (
			<tr key={d} className={currentRow == d && 'cur'}>
				<td
					className={cx({ 'preCur': cols.indexOf(currentCol) === 0 })}
					dangerouslySetInnerHTML={{
						__html: formatNumber(d, initialDict.len['d'][0], initialDict.len['d'][1], filler)
					}}
					/>
				
				{cols.map((col, i) => this.renderCell(
					dict.items[d][col],
					d,
					col,
					cols[i + 1],
					initialDict.len[col]
				))}
				
				{customCols.map(col => (
					<td key={col}
						dangerouslySetInnerHTML={{__html: formatNumber(
							customCells[col][d],
							initialDict.len[col][0],
							initialDict.len[col][1],
							filler
						)}} />
				))}
			</tr>
		)
	},

	render() {
		return (
			<table>
				{this.renderHeader(this.props.cols)}
				<tbody>
					{this.props.rows.map(row => this.renderRow(row))}
				</tbody>
			</table>
		)
	}

})

export default Tbl


/** WEBPACK FOOTER **
 ** ./src/scripts/components/ComplexTable/Tbl.js
 **/